import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../app/Layout";
import MaterialtableDemo from "../../components/plugins/MaterialTableDemo";
import SpinnerLoading from "../../components/Spinners/SpinnerLoading";
import Voucher from "../Contratos/Voucher";
import {
  updateStateModalBasic,
  updateStateModalCustom,
  updateStateModalLarge,
} from "../../../actions/modalActions";
import { listarVouchers } from "../../../actions/pagosActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImport } from "@fortawesome/free-solid-svg-icons";

import "./Vouchers.scss";
import ColumnVisibilityModal from "../../components/Utils/Modals/ColumnVisibilityModal";
import AddNewVoucherModal from "./AddNewVoucherModal";
import ModalBasicwithRedux from "../../../containers/ModalBasicwithRedux";
import ModalLargewhithRedux from "../../../containers/ModalLargewhithRedux";
import ModalCustomWidthwithRedux from "../../../containers/ModalCustomWidthwithRedux";

// src/view/pages/Vouchers/Vouchers.js
// Componente inicial para la página Vouchers (sin lógica)

const Vouchers = ({ id_proyecto }) => {
  //State
  const dispatch = useDispatch();
  const stateCompleto = useSelector((state) => state);
console.log("STATE COMPLETO:", stateCompleto);
  const [showModal, setShowModal] = useState(false);
  const [shouldRefetch, setShouldRefetch] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({});

  const vouchers = useSelector((state) => state.boletas.vouchers);
  console.log("VOUCHERS EN REDUX:", vouchers);
  const loadingVouchers = useSelector((state) => state.boletas.loading);
  const { usuario } = useSelector((state) => state.usuario);

  const handleModalNuevo = (ruta) => {
    dispatch(updateStateModalBasic(<Voucher rutaImagen={ruta} />, "Voucher"));
  };

  // Abre modal para agregar/subir voucher cuando no existe
  const handleAddVoucher = (record) => {
  // Construir el array de archivos existentes
  let archivosExistentes = [];
  
  if (record?.archivo_voucher) {
    archivosExistentes = [{
      archivo_voucher: record.archivo_voucher,
      area_registro: record.area_registro,
      id_registro_pago_voucher: record.id_registro_pago_voucher  // ← AGREGAR ESTA LÍNEA
    }];
  }
  
  const areaRegistro = record?.area_registro || null;

  dispatch(
    updateStateModalLarge(
      <AddNewVoucherModal
        onClose={handleCloseModal}
        id_dt_matricula_proyecto={record.id_dt_matricula_proyecto}
        tp_cuota={record.tp_cuota}
        archivosExistentes={archivosExistentes}
        areaRegistro={areaRegistro}
        onVoucherDeleted={() => setShouldRefetch(true)}
      />,
      "Agregar voucher"
    )
  );
};

  const toggleColumn = (columnName) => {
    const updatedVisibility = {
      ...columnVisibility,
      [columnName]: !columnVisibility[columnName],
    };
    setColumnVisibility(updatedVisibility);
    localStorage.setItem("columnVisibility", JSON.stringify(updatedVisibility));
  };

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(listarVouchers(id_proyecto, 1));
    };
    fetchData();
    setShouldRefetch(false);

    //aqui se actualiza el estado columnVisibility
    const savedVisibility = localStorage.getItem("columnVisibility");
    if (savedVisibility) {
      setColumnVisibility(JSON.parse(savedVisibility));
    }
  }, [id_proyecto,shouldRefetch]);

  const visibleColumns = colums(
    handleModalNuevo,
    handleAddVoucher,
    usuario
  )
    // oculta columnas marcadas manualmente en el modal
    .filter((column) => !columnVisibility[column.key])
    // aplica restricción por rol si la columna define rolesAllowed
    .filter((column) => {
      if (!column.rolesAllowed || !Array.isArray(column.rolesAllowed)) return true;
      const userRole = usuario.nombre_tp_nivel_usuario;
      return userRole ? column.rolesAllowed.includes(String(userRole).toUpperCase()) : false;
    });

  return (
    <div className="vouchers-container">
      <SpinnerLoading loading={loadingVouchers}>
        <div className="box mt-3">
          <div className="m-3">
            <button className="btn btn-primary" onClick={handleShowModal}>
              Columnas
            </button>
          </div>
          <div className="box-primary">
          <div>Total vouchers: {vouchers.length}</div>
            <MaterialtableDemo
              columns={visibleColumns} // Pasar las columnas filtradas
              tabla={vouchers}
              keyCol="id_registro_pago"
            />
          </div>
          <ModalBasicwithRedux />
          <ModalLargewhithRedux />
        </div>
        <ColumnVisibilityModal
          show={showModal}
          onClose={handleCloseModal}
          columns={colums(handleModalNuevo, handleAddVoucher)}
          columnVisibility={columnVisibility}
          onToggleColumn={toggleColumn}
          // opcional:
          // title="Columnas de la lista de alumnos"
          // className="modal-columnas"
        />
      </SpinnerLoading>
    </div>
  );
};

export default Vouchers;

const colums = (handleModalNuevo, handleAddVoucher, usuario) => [
  {
    text: "ID",
    key: "id_dt_matricula_proyecto",
    className: "id_dt_matricula_proyecto",
    sortable: true,
  },
  {
    text: "Fecha de registro",
    key: "fecha_registro",
    className: "fecha_registro",
    sortable: true,
  },
  {
    text: "Producto",
    key: "producto",
    align: "center",
    sortable: true,
    className: "producto",
    cell: (record) => (
      <span>
        <strong>{record.id_producto}</strong> - {record.producto}
      </span>
    ),
  },
  {
    text: "Plan",
    key: "plan",
    align: "center",
    className: "plan",
    sortable: true,
  },
  {
    text: "Asesor",
    key: "asesor",
    align: "center",
    sortable: true,
    className: "asesor",
  },
  {
    text: "DNI",
    key: "dni",
    className: "dni",
    sortable: true,
  },
  {
    text: "Nombres",
    key: "nombres",
    className: "nombres",
    sortable: true,
  },
  {
    text: "Apellidos",
    key: "apellidos",
    className: "apellidos",
    sortable: true,
  },
  {
    text: "Celular",
    key: "celular",
    className: "celular",
    sortable: true,
  },
  {
    text: "Concepto",
    key: "concepto",
    className: "concepto",
    sortable: true,
  },
  {
    text: "Estado",
    key: "estado_voucher",
    className: "estado_voucher",
    sortable: true,
    cell: (record) => {
      const estado = Number(record.estado_voucher);
      const map = {
        1: { text: "Registrado", className: "badge bg-success" },
        2: { text: "Pendiente", className: "badge bg-warning text-dark" },
        3: { text: "Anulado", className: "badge bg-danger" },
      };
      const { text, className } = map[estado] || {
        text: "Desconocido",
        className: "badge bg-secondary",
      };
      return <span className={className}>{text}</span>;
    },
  },{
    text: "Area",
    key: "area_registro",
    align: "center",
    sortable: true,
    rolesAllowed: ["OPERACIONES","FINANZAS"],
    cell: (record) => {
      if(record.area_registro==="1"){
        return "Experiencia"
      }else if(record.area_registro==="2"){
        return "Ventas"
      }
    }
  },
    {
    text: "Voucher",
    key: "archivo_voucher",
    align: "center",
    className: "archivo_voucher",
    sortable: false,
    cell: (record) => {
      return (
        <button
          className="btn btn-primary"
          onClick={() => handleAddVoucher(record)}
        >
          <FontAwesomeIcon icon={faFileImport} />
        </button>
      );
    },
  },
];
